import React, { useMemo, useCallback } from "react"
import { Select, Input } from "antd"
import { RouteStatus } from "../types"

const { Option } = Select
const { Search } = Input

interface RouteFiltersProps {
	selectedStatus?: RouteStatus
	searchQuery: string
	onStatusChange: (status?: RouteStatus) => void
	onSearchChange: (search: string) => void
	loading?: boolean
}

const RouteFilters: React.FC<RouteFiltersProps> = ({
	selectedStatus,
	searchQuery,
	onStatusChange,
	onSearchChange,
	loading = false,
}) => {
	// Memoize status options to prevent unnecessary re-renders
	const statusOptions = useMemo(
		() =>
			[
				{ value: "loading", label: "Loading" },
				{ value: "aggregation", label: "Aggregation" },
				{ value: "ready_to_van", label: "Ready to Van" },
				{ value: "dispatching", label: "Dispatching" },
				{ value: "on_transit", label: "On Transit" },
			] as const,
		[]
	)

	// Memoize search input change handler
	const handleSearchInputChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			onSearchChange(e.target.value)
		},
		[onSearchChange]
	)

	// Memoize status select style
	const statusSelectStyle = useMemo(() => ({ width: 200 }), [])

	// Memoize search input style
	const searchInputStyle = useMemo(() => ({ width: 300 }), [])

	return (
		<div className="RouteFilters">
			<div className="RouteFilters__left">
				<Select
					placeholder="Select Status"
					value={selectedStatus}
					onChange={onStatusChange}
					allowClear
					disabled={loading}
					style={statusSelectStyle}
				>
					{statusOptions.map((option) => (
						<Option key={option.value} value={option.value}>
							{option.label}
						</Option>
					))}
				</Select>
			</div>
			<div className="RouteFilters__right">
				<Search
					placeholder="Search routes..."
					value={searchQuery}
					onChange={handleSearchInputChange}
					onSearch={onSearchChange}
					disabled={loading}
					style={searchInputStyle}
				/>
			</div>
		</div>
	)
}

export default RouteFilters
